<template>
  <div class="header">
    <div class="header-center">
      <img class="logo" src="../images/logo.png" alt="" />

      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-menu-item index="1">首页</el-menu-item>
        <el-submenu index="2">
          <template slot="title">AI生涯规划</template>
          <el-menu-item index="2-1">AI 咨询师</el-menu-item>
          <el-menu-item index="2-2">生涯测评</el-menu-item>
          <el-menu-item index="2-3">学涯规划</el-menu-item>
          <el-menu-item index="2-4">职业探索</el-menu-item>
          <el-menu-item index="2-5">行业百科</el-menu-item>
          <el-menu-item index="2-6">AI 规划书</el-menu-item>
          <el-menu-item index="2-7">职规大赛</el-menu-item>
        </el-submenu>
        <el-menu-item index="3">就业咨询平台</el-menu-item>
        <el-submenu index="8">
          <template slot="title">考编制</template>
          <el-menu-item index="8-1">考国家公务员</el-menu-item>
          <el-menu-item index="8-2">考各省公务员</el-menu-item>
          <el-menu-item index="8-3">考选调生</el-menu-item>
          <el-menu-item index="8-4">考事业编</el-menu-item>
          <el-menu-item index="8-5">地方引才</el-menu-item>
        </el-submenu>
        <el-menu-item index="4">AI简历</el-menu-item>
        <el-menu-item index="5">AI面试</el-menu-item>
        <el-menu-item index="6">就业课程</el-menu-item>
        <el-menu-item index="7">生源数据平台</el-menu-item>

        <!-- <el-menu-item index="4"
          ><a href="https://www.ele.me" target="_blank"
            >订单管理</a
          ></el-menu-item
        > -->
      </el-menu>
      <div class="right">
        <div class="login">就业宝</div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /sr;

export default {
  props: {
    activeIndex: {
      type: String,
      default: "1", // 默认值为 0，表示没有激活项
    },
  },
  data() {
    return {};
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      switch (key) {
        case "1":
          if (this.$route.path !== "/") {
            this.$router.push("/");
          }
          break;
        case "2-1":
          if (this.$route.path !== "/about") {
            this.$router.push("/about");
          }
          break;

        case "8-1":
          if (this.$route.path !== "/examination") {
            this.$router.push("/examination");
          }
          break;
        case "3":
          if (this.$route.path !== "/consulting") {
            this.$router.push("/consulting");
          }
          break;
        case "4":
          if (this.$route.path !== "/jianli") {
            this.$router.push("/jianli");
          }
          window.open("http://resume.qhckj.cc");
          break;
        case "6":
          if (this.$route.path !== "/course") {
            this.$router.push("/course");
          }
          break;
        case "7":
          if (this.$route.path !== "/source") {
            this.$router.push("/source");
          }
          break;
      }
    },
  },
};
</script>
<style lang="scss">
.header {
  width: 1920px;
  height: 70px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
  .header-center {
    width: 1700px;
    height: 100%;
    margin: 0 auto;
    // background: #242527;
    display: flex;
    align-items: center;
    & .right {
      margin-left: 80px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      font-size: 20px;
      color: #20262d;
      cursor: pointer;
      .login {
        position: relative;
      }
    }
    & .logo {
      width: 183px;
      height: 32px;
    }
    & .el-menu--horizontal > .el-submenu .el-submenu__title {
      height: 70px;
      line-height: 70px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      font-size: 20px;
      color: #242527;
    }
    & :v-deep .el-submenu__title i {
      color: #242527;
    }
    & .el-menu--horizontal > .is-active .el-submenu__title {
      color: #0054fe;
    }
    & .el-menu-demo {
      height: 70px;
      margin-left: 60px;
      & .el-menu-item,
      & .el-submenu {
        height: 70px;
        line-height: 70px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        font-size: 20px;
        color: #242527;
        margin-left: 30px;
      }
      & .el-menu-item.is-active {
        color: #0054fe;
        border-bottom: 2px solid #0054fe;
      }
    }
  }
}

.login:hover::after {
  visibility: visible;
  position: absolute;
  top: 40px;
  left: 0px;
  content: "";
  background: url(../images/erweima.png);
  background-position: center;
  background-size: cover;
  width: 150px;
  height: 150px;
  z-index: 999;
}
</style>
